import { createContext } from 'react';
import type { OvertimeContextType } from './OvertimeContextTypes';

export const OvertimeContext = createContext<OvertimeContextType>({} as OvertimeContextType);
export const OVERTIME_CONTEXT_TEST = true;
